export enum MeridianOccupancyType {
	PrimaryResidence = 0,
	SecondaryResidence = 1,
	Investment = 2
}